import React, {useCallback, useState} from 'react';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import LoadingButton from "@material-ui/lab/LoadingButton";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import {useInputState} from "../../../../../../../../../../commons/hooks";

export interface NewServiceDialogProps {
  open: boolean;
  onClose: () => void;
  onCreateService: (name: string, description: string) => Promise<void>;
}

export const NewServiceDialog = ({ open, onClose, onCreateService }: NewServiceDialogProps) => {
  const validate = true;
  const [name, onNameChange, setName, error] = useInputState('', validate);
  const [description, onDescriptionChange, setDescription] = useInputState('');
  const [dirty, setDirty] = useState(false);
  const [loading, setLoading] = useState(false);

  const onCreate = useCallback(async () => {
    setDirty(true);
    if (name && description) {
      try {
        setLoading(true)
        await onCreateService(name, description);
        setLoading(false);
        onClose();
        setName('');
        setDescription('');
        setDirty(false);
      } catch (e: any) {
        alert(e.message); // TODO: notistack
        setLoading(false);
      }
    }
  }, [name, description, onCreateService, onClose, setName, setDescription]);
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Nuevo Servicio</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="description"
          label="Nombre"
          name="name"
          fullWidth
          value={name}
          onChange={onNameChange}
          error={(dirty && !name)  || error?.bool}
          helperText={(dirty && !name && 'Nombre requerido') || (error?.bool && error.message)}
          disabled={loading}
        />
        <TextField
          autoFocus
          margin="dense"
          id="description"
          name="description"
          label="Descripcion"
          fullWidth
          value={description}
          onChange={onDescriptionChange}
          error={dirty && !description}
          helperText={dirty && !description && 'Descripcion requerida'}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" disabled={loading}>
          Cerrar
        </Button>
        <LoadingButton
          color="primary"
          variant="contained"
          autoFocus
          onClick={onCreate}
          disabled={loading}
          loading={loading}
        >
          Crear
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
